<template>
    <div
        class="flex items-start gap-4 p-4 rounded-xl border-l-4 border border-stack-primary bg-theme-canvas transition-all duration-200 hover:shadow-md"
    >
        <div
            class="flex-shrink-0 w-12 h-12 rounded-full bg-stack-primary flex items-center justify-center text-2xl"
        >
            {{ merchant.type | merchantInfo("icon") }}
        </div>
        <div class="flex flex-col min-w-0 flex-1">
            <span class="font-semibold text-theme-base text-base leading-tight">
                {{ merchant.name }}
            </span>
            <span
                class="text-xs font-medium text-stack-primary capitalize mt-1"
            >
                {{ merchant.type | merchantInfo("type") }}
            </span>
            <span class="text-xs text-theme-muted mt-2 truncate">
                🗺 {{ merchant.address }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "MerchantAccessCard",
    props: {
        merchant: {
            type: Object,
            required: true
        }
    }
};
</script>
